// src/components/shared/BulkFillRow.js
// Linha "bulk-fill" usada em IATF / DGFinal / DN — entre busca e tabela
// (2026-05-11, Fase 17.4).
//
// Pattern: 1-2 campos (Autocomplete) que selecionam um valor, e 1-2 botões
// que aplicam esse valor a todas as linhas da tabela (Preencher Todas, Salvar
// Todas).
//
// Substitui o legacy:
//   <div className='grid grid-item p-12 t-6 d-4'>
//     <Autocomplete ... />
//   </div>
//   <Button style={{ width: '48%', height: '46px', marginTop: '10px' }} />
//   <Button style={{ width: '48%', marginLeft: '4%', height: '46px' }} />
//
// API:
//   fields: [{ id, label, options, value, onChange, getOptionLabel? }]
//   actions: [{ label, onClick, variant?: 'primary' | 'secondary', disabled?, icon? }]
//
// Layout: Box flex gap:2 alignItems:center flexWrap:wrap mt:2 mb:1.
// Autocompletes size="small" flex 1 1 200px. AppButtons default 40px flex 0 0 auto.

import React from 'react'
import { Box } from '@mui/material'
import Autocomplete from '../material/Autocomplete'
import AppButton from '../material/AppButton'

export default function BulkFillRow({ fields = [], actions = [] }) {
  if (fields.length === 0 && actions.length === 0) return null

  return (
    <Box
      component='section'
      aria-label='Preenchimento em massa'
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        flexWrap: 'wrap',
        mt: 2,
        mb: 1,
      }}
    >
      {fields.map((f) => (
        <Box
          key={f.id}
          sx={{
            flex: '1 1 200px',
            minWidth: 200,
            '& .MuiOutlinedInput-root': { minHeight: 40 },
          }}
        >
          <Autocomplete
            id={f.id}
            size='small'
            options={f.options || []}
            value={f.value || null}
            onChange={(e, val) => f.onChange(val)}
            label={f.label}
            useDefaultOptionSelected
            getOptionLabel={
              f.getOptionLabel ||
              ((option) => {
                if (option == null) return ''
                if (typeof option === 'string') return option
                return (
                  option.valor ||
                  option.label ||
                  option.name ||
                  option.descricao ||
                  ''
                )
              })
            }
          />
        </Box>
      ))}

      {actions.map((a) => (
        <AppButton
          key={a.label}
          variant={a.variant || 'primary'}
          onClick={a.onClick}
          disabled={a.disabled}
          startIcon={a.icon}
          sx={{ flex: '0 0 auto', minWidth: 140 }}
        >
          {a.label}
        </AppButton>
      ))}
    </Box>
  )
}
